import { SpacingsValues } from '@picsart/cascade';
import { createUseStyles } from 'react-jss';

import { mediaQuery } from '../../../styles/helpers';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    header: {
      background: '#fff',
    },
    breadcrumbs: {
      marginInline: 'auto',
      paddingTop: SpacingsValues.s12,
      paddingBottom: SpacingsValues.s16,
      paddingInline: SpacingsValues.s24,

      [mediaQuery(breakpoints.tablet)]: {
        paddingBottom: SpacingsValues.s12,
      },
    },
    grey: {
      backgroundColor: 'var(--x-bg-5)',
    },
    switcher: {
      marginBottom: SpacingsValues.s24,
    },
  }),
  {
    name: 'WithLanding2',
  },
);

export default useStyles;
